import api from 'axios'

export default {
  sendSMS: (phoneNumber) => (phoneNumber
    ? api.post('/v1/discover/web/sms-share-link', {
      phone_number: phoneNumber,
    })
    : new Promise((res) => res())),
}
